module.exports = __webpack_public_path__ + "static/media/squirrelWhite.4f8c4895.svg";